import { css } from "@emotion/react";

import { colors, ExpandMoreIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";

import SingleFile from "./SingleFile";
import { FileGroupProps } from "./types";

const FileGroup = ({
    title,
    description,
    files,
    isFileUploaded,
    company,
    isExtended,
    isLoading,
    onFileChange,
    onFileUpload,
    onExtensionChange
}: FileGroupProps) => {
    const { gray200, gray900 } = colors;

    return (
        <div
            css={css({
                border: `1px solid ${gray200}`,
                borderRadius: "8px"
            })}
        >
            <div
                css={css({
                    display: "flex",
                    justifyContent: "space-between"
                })}
            >
                <div
                    css={css({
                        color: gray900,
                        lineHeight: "20px",
                        padding: "24px 0 16px 24px"
                    })}
                >
                    <div
                        css={css({
                            fontWeight: "600",
                            letterSpacing: "0.15px",
                            marginBottom: "8px"
                        })}
                    >
                        {title}
                    </div>

                    <div
                        css={css({
                            fontSize: "14px",
                            letterSpacing: "0.1px"
                        })}
                    >
                        {description}
                    </div>
                </div>

                <div
                    css={css({
                        padding: "16px 24px 16px 0",

                        svg: {
                            transform: isExtended
                                ? "rotate(180deg)"
                                : "rotate(0deg)"
                        }
                    })}
                >
                    <Button
                        color={BUTTON_COLORS.Secondary}
                        size={BUTTON_SIZES.Small}
                        variant={BUTTON_VARIANTS.IconOnly}
                        icon={<ExpandMoreIcon />}
                        onClick={onExtensionChange}
                    />
                </div>
            </div>

            <div
                css={css({
                    borderTop: `1px solid ${gray200}`,
                    overflow: "hidden",
                    maxHeight: isExtended ? "450px" : "0",
                    opacity: isExtended ? 1 : 0,
                    transition: `max-height 0.4s ease, opacity 0.4s ease`
                })}
            >
                <div
                    css={css({
                        padding: "16px 24px 24px 24px",

                        "& > div + div": {
                            marginTop: "16px"
                        }
                    })}
                >
                    {files.map(file => {
                        const {
                            id,
                            type,
                            value,
                            additionalParams,
                            customFileLabel
                        } = file;

                        const isMultiType = Array.isArray(type);
                        const mainType = isMultiType ? type[0] : type;

                        const customResource = isMultiType
                            ? type.join(",")
                            : undefined;

                        return (
                            <SingleFile
                                key={id}
                                type={mainType}
                                payloadId={id}
                                value={value}
                                isLoading={isLoading}
                                company={company}
                                hasUploadedFile={
                                    isFileUploaded[mainType] || false
                                }
                                customFileLabel={customFileLabel}
                                additionalParams={additionalParams}
                                customResource={customResource}
                                onChange={onFileChange}
                                onUpload={onFileUpload}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FileGroup;
